export enum Status {
    PENDING = 'Pending',
    DONE = 'Done',
    IN_PROGRESS = 'In progress'
  }
  